import { Box, Typography, LinearProgress } from "@mui/material";

interface MeasurementGaugeProps {
  measurementDays: number;
}

export const MeasurementGauge: React.FC<MeasurementGaugeProps> = ({ measurementDays }) => {
  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const daysInMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  ).getDate();
  const slackDays = 5;
  // Days remaining in the month.
  const daysLeft = daysInMonth - currentDay;
  // Number of additional measurement days needed to hit the goal.
  const required = 16 - measurementDays;

  // Calculate progress on a scale of 0 to 16.
  const progress = Math.min((measurementDays / 16) * 100, 100);

  let color = "green";
  // If it's impossible to hit the goal even with perfect performance.
  if (measurementDays + daysLeft < 16) {
    color = "red";
  } else {
    // Slack: extra days beyond the minimum needed.
    const slack = daysLeft - required;
    if (slack < slackDays) {
      color = "orange";
    } else {
      color = "green";
    }
  }

  if (measurementDays >= 16) {
    color = "green";
  }
  
  return (
    <Box sx={{ width: 100 }}>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 14,
          borderRadius: 5,
          backgroundColor: "#eee",
          "& .MuiLinearProgress-bar": { backgroundColor: color },
        }}
      />
      <Typography variant="caption" align="center" display="block">
        {`${measurementDays} / 16`}
      </Typography>
    </Box>
  );
};